import { render, staticRenderFns } from "./ReplacementsTable.vue?vue&type=template&id=4611a11e&"
import script from "./ReplacementsTable.vue?vue&type=script&lang=ts&"
export * from "./ReplacementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports